import { AtButton, AtButtonDimensions, AtButtonTypes, Media, NavArrowRight, OrContentBlockB } from '@studio/atomic-ui'
import { ProductShowcase } from '../../components/product-showcase'
import { getLabelFromSpaceType } from '../../components/product-showcase/showcase-utils'
import { baseUrl, defaultBuildingName } from '../../env'
import { ContentBlockProps } from './content-block'
import { addBasePath } from '../../utils/helpers'
import { useBuildings } from '../../components/buildings-provider'

export interface FilterBlockProps extends ContentBlockProps {
  dataTestId?: string
  images: Array<Media>
  isNonStudioLocation?: boolean
}

export const FilterBlock = ({
  spacesSection,
  content,
  images,
  dataTestId = 'filter-block',
  ...props
}: FilterBlockProps) => {
  const { getBuildingByKey } = useBuildings()
  const onRedirect = () => {
    const url = new URL(addBasePath(spacesSection.allSpacesButton.actionValue), baseUrl)
    url.searchParams.set('building', props.building ? props.building : defaultBuildingName)
    window.open(url, '_self')
  }

  const buildingName = getBuildingByKey(props.building)?.name ?? ''
  return (
    <div data-testid={dataTestId} className="mx-auto">
      <div
        id="overview"
        className="pl-4 pt-8 sm:pl-4 slg:pl-0 mx-auto lg:pl-[10.4375rem] lg:max-w-screen-lg mb-8"
        ref={(el) => {
          props.observerRefs.current['overview'] = el
        }}
      >
        <OrContentBlockB
          title={content.sectionTitle}
          paragraphOne={content.sectionDescription || ''}
          content={content.sectionBody || []}
          footer={content.sectionFooter || ''}
          mediaOne={images[0]}
          mediaTwo={images[1]}
        />
      </div>
      <div
        id="book-a-space"
        ref={(el) => {
          props.observerRefs.current['book-a-space'] = el
        }}
      >
        <ProductShowcase
          id="tm-building-detail-product-showcase"
          building={content.filterBuilding || props.building}
          type={content.filterType || spacesSection?.spaceType || 'meeting_room'}
          types={content.filterTypes}
          region={content.filterRegion}
          capacity={content.filterCapacity}
          layout="carousel"
          title={
            <h2 className="px-4 lg:px-0 mb-4 lg:mb-6 font-heading font-medium text-32 leading-[1.3] text-neutrals-900">
              {`${props.isNonStudioLocation ? '' : 'Studio '}Spaces at ${buildingName}`}
            </h2>
          }
          customTitle={(type, building) => (
            <h2 className="px-4 lg:px-0 mb-4 lg:mb-6 font-heading font-medium text-32 leading-[1.3] text-neutrals-900">
              {`${props.isNonStudioLocation ? '' : 'Studio '}${getLabelFromSpaceType(type) ?? 'Space'} at ${building}`}
            </h2>
          )}
          hideDivider
          disableSorting
          isBDP
          syncTypeToUrl
          typeQueryParam="product"
          disableRegionFilter={true}
          disableBuildingFilter={false}
        />

        {spacesSection.allSpacesButton?.label && (
          <div className="px-4 pb-4 sm:px-8 md:pt-8 slg:px-12 slg:pb-12 lg:px-40 lg:max-w-screen-lg lg:mx-auto">
            <AtButton
              type={AtButtonTypes.TERTIARY}
              size={AtButtonDimensions.LARGE}
              IconRightRef={NavArrowRight}
              iconRightClasses="hidden lg:block"
              className="pl-0 lg:pl-4"
              title={spacesSection.allSpacesButton?.label}
              onClick={onRedirect}
            />
          </div>
        )}
      </div>
    </div>
  )
}
